import React, { useState } from 'react';

function AskYourConcern() {
    const [businessType, setBusinessType] = useState('');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [media, setMedia] = useState('');
    const [question, setQuestion] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission, e.g., send data to server
        //console.log'Form submitted:', { businessType, state, city, media, question });
    };

    return (
        <div className="concern-container">
            <h4>Ask Your Concern</h4>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <select
                        id="businessType"
                        value={businessType}
                        onChange={(e) => setBusinessType(e.target.value)}
                        className="concern-input"
                    >
                        <option value="">Business Type</option>
                        <option value="option1">Option 1</option>
                        <option value="option2">Option 2</option>
                        <option value="option3">Option 3</option>
                    </select>
                </div>
                <div className="form-group side-by-side">
                    <select
                        id="state"
                        value={state}
                        onChange={(e) => setState(e.target.value)}
                        className="concern-input"
                    >
                        <option value="">State</option>
                        <option value="state1">State 1</option>
                        <option value="state2">State 2</option>
                        <option value="state3">State 3</option>
                    </select>
                    <select
                        id="city"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        className="concern-input"
                    >
                        <option value="">City</option>
                        <option value="city1">City 1</option>
                        <option value="city2">City 2</option>
                        <option value="city3">City 3</option>
                    </select>
                </div>
                <div className="form-group">
                    <input
                        type="text"
                        id="media"
                        value={media}
                        onChange={(e) => setMedia(e.target.value)}
                        placeholder="Add Media * "
                        className="concern-input"
                    />
                </div>
                <div className="form-group">
                    <textarea
                        id="question"
                        value={question}
                        onChange={(e) => setQuestion(e.target.value)}
                        placeholder="Ask Your Question / Query"
                        className="concern-input"
                        rows={6}
                    />
                </div>
                <div className="form-group">
                    <button type="submit" className="concern-submit-btn">Submit</button>
                </div>
            </form>
        </div>
    );
}

export default AskYourConcern;
